import { Box, Dialog } from "@mui/material";
import React, { ReactNode, type JSX } from 'react';

export type FullScreenDialogCloseReason = "backdropClick" | "escapeKeyDown";

export type FullScreenDialogProps<TReason = FullScreenDialogCloseReason> = {
    open: boolean;
    enableEscapeKeyDown?: boolean;
    onClose: (reason: TReason) => void;
    children?: ReactNode;
};

export default function FullScreenDialog({
    children,
    open,
    enableEscapeKeyDown = false,
    onClose
}: FullScreenDialogProps): JSX.Element {

    return (
        <Dialog
            open={open}
            onClose={(_event, reason) => {
                if(reason != "escapeKeyDown" || enableEscapeKeyDown) {
                    onClose(reason);
                }
            }}
            fullScreen={true}
            sx={{
                padding: 'env(safe-area-inset-top) env(safe-area-inset-right) env(safe-area-inset-bottom) env(safe-area-inset-left)'
            }}
        >
            <Box sx={{
                display: "flex",
                flexDirection: "column",
                flexGrow: 1,
                overflow: "hidden"
            }}>
                
                {children}

            </Box>

        </Dialog>
    );
}
